import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BlurService {
  private _isBlurEnable$ = new BehaviorSubject<boolean>(false);
  public isBlurEnable$ = this._isBlurEnable$.asObservable();

  public enableBlur(): void {
    this._isBlurEnable$.next(true);
  }

  public disableBlur(): void {
    this._isBlurEnable$.next(false);
  }
}
